import CloseIcon from "@mui/icons-material/Close";
// import { Link } from "react-router-dom";
import {
    Box,
    Grid,
    Stack,
    Typography,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    PaginationItem,
    Pagination,
    Breadcrumbs,
    Button,
    Modal,
    TextField,
    InputAdornment,
    Popover,
    Link,
    MenuItem,
    Select,
    Card,
    CardContent
} from "@mui/material";
import { ReactComponent as BacktoJob } from "../assets/images/back-to-jobs-black.svg";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import moment, { duration } from "moment";
import React, { useState, useEffect } from "react";
import noCandidate from "../assets/images/Nomatching candidates.png";
import { ReactComponent as ArrowBackIcon } from "../assets/images/arrow-left.svg";
import { ReactComponent as ArrowForwardIcon } from "../assets/images/arrow-right.svg";
import { useRef } from "react";
import { handleSpaces, getErrorMessage, functiondisable, functionenable } from "../utils/helper.js";
import { ReactComponent as SearchIcon } from "../assets/images/new-search-gray-icon.svg";
import ClearIcon from "@mui/icons-material/Clear";
import FilterListOffIcon from "@mui/icons-material/FilterListOff";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import IconButton from "@mui/material/IconButton";
import { useLocation, useNavigate } from "react-router-dom";
import MeatballMenu from './ActionButton';
import axios from "axios";
import DateRangePicker from 'react-bootstrap-daterangepicker';
import '../assets/styles/stylesheets/daterangepicker.css';
import { danger, success } from '../utils/message-box.js';
import axiosInstance from '../Services/axiosInstance.js';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import { styled, useTheme } from '@mui/material/styles';
import useMediaQuery from "@mui/material/useMediaQuery";

const BootstrapTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} arrow classes={{ popper: className }} />
))(({ theme }) => ({
    [`& .${tooltipClasses.arrow}`]: {
        color: theme.palette.common.black,
    },
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: theme.palette.common.black,
    },
}));

export default function CustomersList(props) {
    const navigate = useNavigate();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("md"));
    const [isLoading, setIsLoading] = useState(false);
    const [candidates, setCandidates] = useState();
    const [pairsCount, setPairsCount] = useState(0);
    const [prepaidAmount, setPrepaidAmount] = useState(0);
    const [currentPage, setCurrentpage] = useState(1);
    const [totalCount, setTotalCount] = useState(0);
    const [totalPages, setTotalPages] = useState(0);
    const [totalOrdersCount, setTotalOrdersCount] = useState(0);
    const [firstTimeLoad, setFirstTimeLoad] = useState(false);
    const inputRef = React.useRef();
    const divRef = useRef(null);
    const [filterData, setFilterData] = useState({});
    const [skills, setSkills] = useState([]);
    const [anchor, setAnchorEl] = useState(null);
    const [open, setOpen] = useState(false);
    const [openSnackbar, setOpenSnakbar] = useState(false);
    const [toastMessage, setToastMessage] = useState("");
    const [searchKeyword, setSearchKeyword] = useState("");
    const [spAmount, setSpAmount] = useState();
    const [bpAmount, setBpAmount] = useState();
    const [platform, setPlatform] = useState("");
    const [downloadLoader, setDownloadLoader] = useState(false);
    const [emailConfirmation, setEmailConfirmation] = useState(false);
    const [previouslySearchedKeyword, setPreviouslySearchedKeyword] = useState("");
    const id = open ? "simple-popover" : undefined;
    const [dateRange, setDateRange] = useState({ start: moment().subtract(29, 'days'), end: moment() });
    const { start, end } = dateRange;
    const [dateFilter, setDateFilter] = useState(false);
    const [dateRangePickerKey, setDateRangePickerKey] = useState(0);
    const hasActiveFilters = dateFilter
        || (platform !== "" && platform !== "all")
        || previouslySearchedKeyword !== ""
        || searchKeyword !== "";
    useEffect(() => {
        getCustomers();
    }, []);
    const handleCallback = (start, end) => {
        setDateRange({ start, end });
        setDateFilter(true);
        let start_date = moment(start).format("YYYY-MM-DD");
        let end_date = moment(end).format("YYYY-MM-DD");
        let url = "";
        if (platform != "" && platform != "all" && previouslySearchedKeyword != "") {
            url = `/api/v1/customers?page=${1}&page_size=${10}&start_date=${start_date}&end_date=${end_date}&business_type=${platform}&query=` + (previouslySearchedKeyword?.charAt(0) == "#" ? previouslySearchedKeyword?.split("#")[1] : previouslySearchedKeyword)
        } else if (platform != "" && platform != "all") {
            url = `/api/v1/customers?page=${1}&page_size=${10}&start_date=${start_date}&end_date=${end_date}&business_type=${platform}`
        } else if (previouslySearchedKeyword != "") {
            url = `/api/v1/customers?page=${1}&page_size=${10}&start_date=${start_date}&end_date=${end_date}&query=` + (previouslySearchedKeyword?.charAt(0) == "#" ? previouslySearchedKeyword?.split("#")[1] : previouslySearchedKeyword)
        } else {
            url = `/api/v1/customers?page=${1}&page_size=${10}&start_date=${start_date}&end_date=${end_date}`
        }
        axiosInstance.get(url)
            .then((res) => {
                setCurrentpage(1);
                setCandidates(res.data.data.data);
                setPairsCount(res.data.data.total_pairs_count);
                setPrepaidAmount(res.data.data.total_prepaid_amount);
                setSpAmount(res.data.data.sp_amount);
                setBpAmount(res.data.data.bp_amount);
                setTotalCount(res.data.totalCount);
                setTotalPages(res.data.totalPages || Math.ceil(res.data.totalCount / 10) || 1);
                setTotalOrdersCount(res.data.data.total_orders_count);
            }).catch((e) => {
                danger(getErrorMessage(e, 'Failed to load customers. Please try again.'));
            });
    };
    const handleClickOnCancel = (event, picker) => {
        setDateRange({ start: moment().subtract(29, 'days'), end: moment() });
        setDateFilter(false);
    };
    const label = start.format('MMM D, YYYY') + ' - ' + end.format('MMM D, YYYY');
    const copyBarcodeTrackingNumber = async (barcode) => {
        if (!barcode) return;
        const text = `Indian postal service tracking number - ${barcode}`;
        try {
            await navigator.clipboard.writeText(text);
            success('Tracking number copied to clipboard.');
        } catch {
            danger('Failed to copy tracking number.');
        }
    };
    const columns = [
        // { col: "Customer Name", key: "name", width: "180px" },
        { col: "Order Date", key: "created_at", width: "120px" },
        { col: "Barcode", key: "barcode", width: "120px" },
        { col: "Phone Number", key: "phone_number", width: "120px" },
        { col: "Address", key: "address", width: "120px" },
        { col: "Status", key: "order_status", width: "150px" },
        { col: "Size Details", key: "size_details", width: "150px" },
        { col: "Qantity", key: "order_quantity", width: "80px" },
        { col: "COD", key: "cod", width: "80px" },
        { col: "Prepaid", key: "prepaid", width: "80px" },
        { col: "Pincode", key: "pincode", width: "80px" },
        { col: "Alt Phone", key: "alt_phone_number", width: "120px" },
        { col: "Printed", key: "is_printed", width: "80px" },
        { col: "Weight", key: "weight", width: "120px" },
        { col: "Delivary Charges", key: "delivary_charges", width: "80px" },
        { col: "RCA", key: "received_cod_amount", width: "80px" },
        { col: "Payment Status", key: "payment_status", width: "125px" },
        { col: "Commission", key: "commision", width: "80px" },
        { col: "External ID", key: "bighat_order_id", width: "120px" },
        { col: "Complaints", key: "complaint_number", width: "100px" },
        { col: "Created By", key: "created_by", width: "80px" },
        { col: "Remarks", key: "remarks", width: "120px" },
    ];
    const handleChangePage = (event, newPage) => {
        setCurrentpage(newPage);
        setFirstTimeLoad(true);
        getCustomers(newPage);
    };
    const handleConfirmPopup = () => {
        setEmailConfirmation(false);
    };
    const handleClosePopover = () => {
        setOpen(false);
        functionenable();
    };
    const handleEnterKey = (e) => {
        setSearchKeyword(e.target.value);
        if (
            e.key === "Enter" &&
            e.target.value !== "" &&
            e.target.value !== previouslySearchedKeyword
        ) {
            e.preventDefault();
            search();
        }
        if (
            e.type === "input" &&
            e.target.value === "" &&
            previouslySearchedKeyword !== ""
        ) {
            e.preventDefault();
            search(e);
        }
    };
    const handleClick = (e, skills) => {
        setSkills(skills);
        setAnchorEl(e.currentTarget);
        setOpen(true);
        functiondisable();
    };
    const getCustomers = (newPage) => {
        setFirstTimeLoad(true);
        let url = ''
        if (searchKeyword != "" && dateFilter && platform != "" && platform !== "all") {
            let start_date = moment(dateRange.start).format("YYYY-MM-DD");
            let end_date = moment(dateRange.end).format("YYYY-MM-DD");
            url = `/api/v1/customers?page=${newPage ? newPage : currentPage}&page_size=${10}&start_date=${start_date}&end_date=${end_date}&business_type=${platform}&query=` + (searchKeyword?.charAt(0) == "#" ? searchKeyword?.split("#")[1] : searchKeyword);
        } else if (dateFilter && platform != "" && platform !== "all") {
            let start_date = moment(dateRange.start).format("YYYY-MM-DD");
            let end_date = moment(dateRange.end).format("YYYY-MM-DD");
            url = `/api/v1/customers?page=${newPage ? newPage : currentPage}&page_size=${10}&start_date=${start_date}&end_date=${end_date}&business_type=${platform}`;
        } else if (dateFilter && searchKeyword != "") {
            let start_date = moment(dateRange.start).format("YYYY-MM-DD");
            let end_date = moment(dateRange.end).format("YYYY-MM-DD");
            url = `/api/v1/customers?page=${newPage ? newPage : currentPage}&page_size=${10}&start_date=${start_date}&end_date=${end_date}&query=` + (searchKeyword?.charAt(0) == "#" ? searchKeyword?.split("#")[1] : searchKeyword);
        } else if (platform != "" && platform !== "all" && searchKeyword != "") {
            url = `/api/v1/customers?page=${newPage ? newPage : currentPage}&page_size=${10}&business_type=${platform}&query=` + (searchKeyword?.charAt(0) == "#" ? searchKeyword?.split("#")[1] : searchKeyword);
        } else if (dateFilter) {
            let start_date = moment(dateRange.start).format("YYYY-MM-DD");
            let end_date = moment(dateRange.end).format("YYYY-MM-DD");
            url = `/api/v1/customers?page=${newPage ? newPage : currentPage}&page_size=${10}&start_date=${start_date}&end_date=${end_date}`;
        } else if (platform != "" && platform !== "all") {
            url = `/api/v1/customers?page=${newPage ? newPage : currentPage}&page_size=${10}&business_type=${platform}`;
        } else if (searchKeyword != "") {
            url = `/api/v1/customers?page=${newPage ? newPage : currentPage}&page_size=${10}&query=` + (searchKeyword?.charAt(0) == "#" ? searchKeyword?.split("#")[1] : searchKeyword);
        } else {
            let start_date = moment(dateRange.start).format("YYYY-MM-DD");
            let end_date = moment(dateRange.end).format("YYYY-MM-DD");
            url = `/api/v1/customers?page=${newPage ? newPage : currentPage}&page_size=${10}&start_date=${start_date}&end_date=${end_date}`;
        }
        axiosInstance.get(url)
            .then((res) => {
                console.log(res.data.data.data);
                setCandidates(res.data.data.data);
                setPairsCount(res.data.data.total_pairs_count);
                setPrepaidAmount(res.data.data.total_prepaid_amount);
                setSpAmount(res.data.data.sp_amount);
                setBpAmount(res.data.data.bp_amount);
                setTotalCount(res.data.totalCount);
                setTotalPages(res.data.totalPages || Math.ceil(res.data.totalCount / 10) || 1);
                setTotalOrdersCount(res.data.data.total_orders_count);
                // setCurrentpage(res.data.currentPage)
                setFirstTimeLoad(false);
            }).catch((e) => {
                setFirstTimeLoad(false);
                danger('Something went wrong.');
            });
    };
    const updateCustomer = (data, status) => {
        let payload = null;
        if (status === "Done") {
            payload = { ...data, payment_status: status } 
        } else {
            payload = { ...data, order_status: status }
        }
        axiosInstance.put(`/api/v1/customers/${data.id}`, payload)
            .then((res) => {
                success('Customer details updated successfully.');
                getCustomers();
            }).catch((error) => {
                danger(getErrorMessage(error, 'Failed to update customer. Please try again.'));
            });
    };
    const deleteCustomer = (id) => {
        axiosInstance.delete(`/api/v1/customers/${id}`)
            .then((res) => {
                success('Customer details deleted successfully.');
                getCustomers();
            }).catch((error) => {
                danger(getErrorMessage(error, 'Failed to delete customer. Please try again.'));
            });
    };
    const getCustomersOnBusinessType = async (value) => {
        let url = "";
        if (dateFilter && value != "all" && previouslySearchedKeyword != "") {
            let start_date = moment(dateRange.start).format("YYYY-MM-DD");
            let end_date = moment(dateRange.end).format("YYYY-MM-DD");
            url = `/api/v1/customers?page=${1}&page_size=${10}&start_date=${start_date}&end_date=${end_date}&business_type=${value}&query=` + (previouslySearchedKeyword?.charAt(0) == "#" ? previouslySearchedKeyword?.split("#")[1] : previouslySearchedKeyword)
        } else if (dateFilter && value != "all") {
            let start_date = moment(dateRange.start).format("YYYY-MM-DD");
            let end_date = moment(dateRange.end).format("YYYY-MM-DD");
            url = `/api/v1/customers?page=${1}&page_size=${10}&start_date=${start_date}&end_date=${end_date}&business_type=${value}`
        } else if (value != "all" && previouslySearchedKeyword != "") {
            url = `/api/v1/customers?page=${1}&page_size=${10}&business_type=${value}&query=` + (previouslySearchedKeyword?.charAt(0) == "#" ? previouslySearchedKeyword?.split("#")[1] : previouslySearchedKeyword)
        } else if (dateFilter && value == "all" && previouslySearchedKeyword != "") {
            let start_date = moment(dateRange.start).format("YYYY-MM-DD");
            let end_date = moment(dateRange.end).format("YYYY-MM-DD");
            url = `/api/v1/customers?page=${1}&page_size=${10}&start_date=${start_date}&end_date=${end_date}&query=` + (previouslySearchedKeyword?.charAt(0) == "#" ? previouslySearchedKeyword?.split("#")[1] : previouslySearchedKeyword)
        } else if (dateFilter && value == "all") {
            let start_date = moment(dateRange.start).format("YYYY-MM-DD");
            let end_date = moment(dateRange.end).format("YYYY-MM-DD");
            url = `/api/v1/customers?page=${1}&page_size=${10}&start_date=${start_date}&end_date=${end_date}`
        } else if (value == "all" && previouslySearchedKeyword != "") {
            url = `/api/v1/customers?page=${1}&page_size=${10}&query=` + (previouslySearchedKeyword?.charAt(0) == "#" ? previouslySearchedKeyword?.split("#")[1] : previouslySearchedKeyword)
        } else if (value == "all") {
            url = `/api/v1/customers?page=${1}&page_size=${10}`
        } else {
            url = `/api/v1/customers?page=${1}&page_size=${10}&business_type=${value}`
        }
        await axiosInstance.get(url)
            .then((res) => {
                setCandidates(res.data.data.data);
                setPairsCount(res.data.data.total_pairs_count);
                setPrepaidAmount(res.data.data.total_prepaid_amount);
                setSpAmount(res.data.data.sp_amount);
                setBpAmount(res.data.data.bp_amount);
                setTotalCount(res.data.totalCount);
                setTotalPages(res.data.totalPages || Math.ceil(res.data.totalCount / 10) || 1);
                setTotalOrdersCount(res.data.data.total_orders_count);
                setFirstTimeLoad(false);
            })
            .catch(function (error) {
                setFirstTimeLoad(false);
                // Silent error for non-critical operations
            });
    };
    const search = async (e) => {
        setFirstTimeLoad(true);
        let url = "";
        let searchValue =
            e?.type === "input" && e?.target?.value === "" ? "" : searchKeyword;
            if (dateFilter && platform != "all" && platform != "" && searchValue != "") {
                let start_date = moment(dateRange.start).format("YYYY-MM-DD");
                let end_date = moment(dateRange.end).format("YYYY-MM-DD");
                url = `/api/v1/customers?page=${1}&page_size=${10}&start_date=${start_date}&end_date=${end_date}&business_type=${platform}&query=` + (searchValue?.charAt(0) == "#" ? searchValue?.split("#")[1] : searchValue)
            } else if (platform != "all"  && platform != "" && searchValue != "") {
                url = `/api/v1/customers?page=${1}&page_size=${10}&business_type=${platform}&query=` + (searchValue?.charAt(0) == "#" ? searchValue?.split("#")[1] : searchValue)
            } else if (dateFilter && platform == "all" && searchValue != "") {
                let start_date = moment(dateRange.start).format("YYYY-MM-DD");
                let end_date = moment(dateRange.end).format("YYYY-MM-DD");
                url = `/api/v1/customers?page=${1}&page_size=${10}&start_date=${start_date}&end_date=${end_date}&query=` + (searchValue?.charAt(0) == "#" ? searchValue?.split("#")[1] : searchValue)
            } else if (dateFilter && searchValue != "") {
                let start_date = moment(dateRange.start).format("YYYY-MM-DD");
                let end_date = moment(dateRange.end).format("YYYY-MM-DD");
                url = `/api/v1/customers?page=${1}&page_size=${10}&start_date=${start_date}&end_date=${end_date}&query=` + (searchValue?.charAt(0) == "#" ? searchValue?.split("#")[1] : searchValue)
            } else if (searchValue != "" && platform == "all") {
                url = `/api/v1/customers?page=${1}&page_size=${10}&query=` + (searchValue?.charAt(0) == "#" ? searchValue?.split("#")[1] : searchValue)
            } else {
                url = `/api/v1/customers?page=${1}&page_size=${10}&query=` + (searchValue?.charAt(0) == "#" ? searchValue?.split("#")[1] : searchValue)
            }
        setPreviouslySearchedKeyword(searchValue?.charAt(0) == "#" ? searchValue?.split("#")[1] : searchValue);
        await axiosInstance.get(url)
            .then((res) => {
                setCandidates(res.data.data.data);
                setPairsCount(res.data.data.total_pairs_count);
                setPrepaidAmount(res.data.data.total_prepaid_amount);
                setSpAmount(res.data.data.sp_amount);
                setBpAmount(res.data.data.bp_amount);
                setTotalCount(res.data.totalCount);
                setTotalPages(res.data.totalPages || Math.ceil(res.data.totalCount / 10) || 1);
                setTotalOrdersCount(res.data.data.total_orders_count);
                setFirstTimeLoad(false);
            })
            .catch(function (error) {
                setFirstTimeLoad(false);
                // Silent error for non-critical operations
            });
    };
    function showDownload() {
        if (dateFilter && platform != "all" && platform != "" && (previouslySearchedKeyword.toLowerCase() === "disputed" || previouslySearchedKeyword.toLowerCase() === "in-transit") && totalCount > 0) {
            return true;
        } else if (dateFilter && platform != "all" && platform != "" && totalCount > 0 && previouslySearchedKeyword == "") {
            return true;
        } else if (dateFilter && totalCount > 0 && previouslySearchedKeyword == "" && (platform == "all" || platform == "")) {
            return true;
        } else if (platform != "all" && platform != "" && (previouslySearchedKeyword.toLowerCase() === "disputed" || previouslySearchedKeyword.toLowerCase() === "in-transit") && totalCount > 0) {
            return true;
        } else if (platform != "all" && platform != "" && totalCount > 0 && previouslySearchedKeyword == "") {
            return true;
        } else if ((previouslySearchedKeyword.toLowerCase() === "disputed" || previouslySearchedKeyword.toLowerCase() === "in-transit") && totalCount > 0) {
            return true;
        }
        return;
    };
    const clearSearch = async (e) => {
        setCurrentpage(1);
        setPreviouslySearchedKeyword("");
        setSearchKeyword("");
        let url = "";
        if (dateFilter && platform != "all" && platform != "") {
            let start_date = moment(dateRange.start).format("YYYY-MM-DD");
            let end_date = moment(dateRange.end).format("YYYY-MM-DD");
            url = `/api/v1/customers?page=${1}&page_size=${10}&start_date=${start_date}&end_date=${end_date}&business_type=${platform}`
        } else if (platform != "all"  && platform != "") {
            url = `/api/v1/customers?page=${1}&page_size=${10}&business_type=${platform}`
        } else if (dateFilter && platform == "all") {
            let start_date = moment(dateRange.start).format("YYYY-MM-DD");
            let end_date = moment(dateRange.end).format("YYYY-MM-DD");
            url = `/api/v1/customers?page=${1}&page_size=${10}&start_date=${start_date}&end_date=${end_date}`
        } else if (dateFilter) {
            let start_date = moment(dateRange.start).format("YYYY-MM-DD");
            let end_date = moment(dateRange.end).format("YYYY-MM-DD");
            url = `/api/v1/customers?page=${1}&page_size=${10}&start_date=${start_date}&end_date=${end_date}`
        } else if (platform == "all") {
            url = `/api/v1/customers?page=${1}&page_size=${10}`
        } else {
            let start_date = moment(dateRange.start).format("YYYY-MM-DD");
            let end_date = moment(dateRange.end).format("YYYY-MM-DD");
            url = `/api/v1/customers?page=${1}&page_size=${10}&start_date=${start_date}&end_date=${end_date}`;
        }
        axiosInstance.get(url)
            .then((res) => {
                setCandidates(res.data.data.data);
                setPairsCount(res.data.data.total_pairs_count);
                setPrepaidAmount(res.data.data.total_prepaid_amount);
                setSpAmount(res.data.data.sp_amount);
                setBpAmount(res.data.data.bp_amount);
                setTotalCount(res.data.totalCount);
                setTotalPages(res.data.totalPages || Math.ceil(res.data.totalCount / 10) || 1);
                setTotalOrdersCount(res.data.data.total_orders_count);
                // setCurrentpage(res.data.currentPage)
                setFirstTimeLoad(false);
            }).catch((e) => {
                danger(getErrorMessage(e, 'Failed to load customers. Please try again.'));
            });
    };
    const clearAllFilters = () => {
        const resetRange = { start: moment().subtract(29, 'days'), end: moment() };
        setCurrentpage(1);
        setDateFilter(false);
        setDateRange(resetRange);
        setDateRangePickerKey((key) => key + 1);
        setPlatform("");
        setSearchKeyword("");
        setPreviouslySearchedKeyword("");
        if (inputRef.current) {
            inputRef.current.value = "";
        }
        setFirstTimeLoad(true);
        const start_date = resetRange.start.format("YYYY-MM-DD");
        const end_date = resetRange.end.format("YYYY-MM-DD");
        const url = `/api/v1/customers?page=1&page_size=10&start_date=${start_date}&end_date=${end_date}`;

        axiosInstance.get(url)
            .then((res) => {
                setCandidates(res.data.data.data);
                setPairsCount(res.data.data.total_pairs_count);
                setPrepaidAmount(res.data.data.total_prepaid_amount);
                setSpAmount(res.data.data.sp_amount);
                setBpAmount(res.data.data.bp_amount);
                setTotalCount(res.data.totalCount);
                setTotalPages(res.data.totalPages || Math.ceil(res.data.totalCount / 10) || 1);
                setTotalOrdersCount(res.data.data.total_orders_count);
                setFirstTimeLoad(false);
            }).catch((e) => {
                setFirstTimeLoad(false);
                danger(getErrorMessage(e, 'Failed to load customers. Please try again.'));
            });
    };
    const downloadCustomerExcel = async (startDate, endDate) => {
        setDownloadLoader(true);
        let start_date = moment(dateRange.start).format("YYYY-MM-DD");
        let end_date = moment(dateRange.end).format("YYYY-MM-DD");
        try {
            const params = platform != "" && platform != "all" ? { start_date, end_date, business_type: platform } : { start_date, end_date };
            const response = await axiosInstance.get('/api/v1/customers/export', {
                responseType: 'blob',
                params,
            });
            const urlBlob = window.URL.createObjectURL(new Blob([response.data]));
            // Create a link element to trigger the download
            const link = document.createElement('a');
            link.href = urlBlob;
            link.setAttribute('download', 'customers.xlsx'); // Filename
            document.body.appendChild(link);
            link.click();
            // Clean up and remove the link
            link.parentNode.removeChild(link);
            window.URL.revokeObjectURL(urlBlob);
            setDownloadLoader(false);
            success('Document downloaded successfully.');
        } catch (error) {
            setDownloadLoader(false);
            danger(getErrorMessage(error, 'Failed to download file. Please try again.'));
            console.error('There was an error downloading the file:', error);
        }
    };
    const downloadComplaintExcel = async (status) => {
        try {
            const params = platform != "all" && platform != "" ? { query: status, business_type: platform } : { query: status };
            const response = await axiosInstance.get('/api/v1/customers/export', {
                responseType: 'blob',
                params,
            });
            const urlBlob = window.URL.createObjectURL(new Blob([response.data]));
            // Create a link element to trigger the download
            const link = document.createElement('a');
            link.href = urlBlob;
            link.setAttribute('download', 'customers.xlsx'); // Filename
            document.body.appendChild(link);
            link.click();
            // Clean up and remove the link
            link.parentNode.removeChild(link);
            window.URL.revokeObjectURL(urlBlob);
            success('Document downloaded successfully.');
        } catch (error) {
            danger(getErrorMessage(error, 'Failed to download file. Please try again.'));
            console.error('There was an error downloading the file:', error);
        }
    };
    function getTotalQuantity(items) {
        return items.reduce((total, item) => total + item.quantity, 0);
    };
    function getTotalOrderQuantity(items) {
        return items.reduce((total, item) => total + (item?.order_status !== "Returned" ? item.order_quantity : 0), 0);
    }
    return (
        <>
            <Grid container item>
                <Grid
                    item
                    lg={12}
                    md={12}
                    xs={12}
                    sx={{ pb: 1, mt: 1 }}
                    className="userBg-space resolution-view my-jobs-align project-preview-align screening-align myJobs-status galaxy-block galaxy-padding"
                >
                    <Typography>
                        <Breadcrumbs
                            aria-label="breadcrumb"
                            className="pt-0 pb-10"
                            separator={<NavigateNextIcon fontSize="small" aria-label="Next icon" />}
                        >
                            {/* <Link
                                className="cursor-hover f-12 gray9 font-weight-600 text-decoration-none gal-slot-align"
                                to="/enterprise/talent-console"
                                tabIndex={0}
                            > */}
                            <span className="cursor-hover d-flex f-12 gray9 font-weight-600 text-decoration-none gal-slot-align" onClick={() => navigate('/home')}>
                                <BacktoJob className="mr-10" />
                                Back to Home
                            </span>
                            {/* </Link> */}
                        </Breadcrumbs>
                    </Typography>
                    <Typography className="d-flex align-center">
                        <Typography className="heading-text-color f-20 font-weight-600">
                            {"Customers"}{" "}
                        </Typography>
                        <Box className="gray7 f-14 font-weight-400 ml-5">
                            {"(" + totalOrdersCount + ")"}
                        </Box>
                    </Typography>
                    <Grid>
                        <Grid container spacing={1} className="">
                            {!isMobile && <Grid item lg={5} md={5} xs={12} className="score-aged-align galaxy-fold-top myjobs-ipad">
                                {/* <Grid container className="">
                                    <Grid item lg={5.7} md={5.7} xs={12} className="d-flex align-center sPbalanceStatus mt-10">
                                        SP COD Received Amount : {spAmount?.received_amount || 0} <br />
                                        SP COD Balance Amount : {(spAmount?.balance_amount - spAmount?.received_amount) || 0}
                                    </Grid>
                                    <Grid item lg={0.5} md={0.5} xs={12}></Grid>
                                    <Grid item lg={5.7} md={5.7} xs={12} className="d-flex align-center bPbalanceStatus mt-10">
                                        BP COD Received Amount : {bpAmount?.received_amount || 0} <br />
                                        BP COD Balance Amount : {(bpAmount?.balance_amount - bpAmount?.received_amount) || 0}
                                    </Grid>
                                </Grid> */}
                                <Grid container spacing={2} className="cod-status-container">
                                <Grid item lg={6} md={6} xs={12}>
                                    <Card className="cod-card sPbalanceStatus">
                                    <CardContent>
                                        <Typography variant="h6" className="cod-title">
                                        SP COD
                                        </Typography>
                                        <Typography variant="body1" className="f-14">
                                        <strong>Received Amount:</strong> ₹{spAmount?.received_amount?.toLocaleString('en-IN') || 0}
                                        </Typography>
                                        <Typography variant="body1" className="f-14">
                                        <strong>Balance Amount:</strong> ₹{(spAmount?.balance_amount - spAmount?.received_amount)?.toLocaleString('en-IN') || 0}
                                        </Typography>
                                        <Typography variant="body1" className="f-14">
                                        <strong>Delivery Charges:</strong> ₹{Math.round(spAmount?.delivary_charges || 0).toLocaleString('en-IN')}
                                        </Typography>
                                    </CardContent>
                                    </Card>
                                </Grid>
                                <Grid item lg={6} md={6} xs={12}>
                                    <Card className="cod-card bPbalanceStatus">
                                    <CardContent>
                                        <Typography variant="h6" className="cod-title">
                                        BP COD
                                        </Typography>
                                        <Typography variant="body1" className="f-14">
                                        <strong>Received Amount:</strong> ₹{bpAmount?.received_amount?.toLocaleString('en-IN') || 0}
                                        </Typography>
                                        <Typography variant="body1" className="f-14">
                                        <strong>Balance Amount:</strong> ₹{(bpAmount?.balance_amount - bpAmount?.received_amount)?.toLocaleString('en-IN') || 0}
                                        </Typography>
                                        <Typography variant="body1" className="f-14">
                                        <strong>Delivery Charges:</strong> ₹{Math.round(bpAmount?.delivary_charges || 0).toLocaleString('en-IN')}
                                        </Typography>
                                    </CardContent>
                                    </Card>
                                </Grid>
                                </Grid>
                            </Grid>}
                            <Grid item lg={7} md={7} xs={12}>
                                <Grid container spacing={2} className="align-center d-flex search-job justify-end responsive-layout customers-list-filters">
                                    <Grid item lg={3.5} md={3.5} xs={12} className="bluk-upload-daterangepicker">
                                        <DateRangePicker
                                            key={dateRangePickerKey}
                                            initialSettings={{
                                                startDate: start.toDate(),
                                                endDate: end.toDate(),
                                                ranges: {
                                                    Today: [moment().toDate(), moment().toDate()],
                                                    Yesterday: [
                                                        moment().subtract(1, 'days').toDate(),
                                                        moment().subtract(1, 'days').toDate(),
                                                    ],
                                                    'Last 7 Days': [
                                                        moment().subtract(6, 'days').toDate(),
                                                        moment().toDate(),
                                                    ],
                                                    'Last 30 Days': [
                                                        moment().subtract(29, 'days').toDate(),
                                                        moment().toDate(),
                                                    ],
                                                    'This Month': [
                                                        moment().startOf('month').toDate(),
                                                        moment().endOf('month').toDate(),
                                                    ],
                                                    'Last Month': [
                                                        moment().subtract(1, 'month').startOf('month').toDate(),
                                                        moment().subtract(1, 'month').endOf('month').toDate(),
                                                    ],
                                                },
                                            }}
                                            onCallback={handleCallback}
                                            onCancel={handleClickOnCancel}
                                        >
                                            <div
                                                id="reportrange"
                                                className={dateFilter ? "chip-dropdown-active position-issue customers-date-range-trigger" : "customers-date-range-trigger"}
                                            >
                                                <i className="fa fa-calendar" aria-hidden="true" />
                                                <span
                                                    className="customers-date-range-label"
                                                    style={{ color: dateFilter ? "#fff" : undefined }}
                                                >
                                                    {label}
                                                </span>
                                                <i className="fa fa-caret-down" aria-hidden="true" />
                                            </div>
                                        </DateRangePicker>
                                    </Grid>
                                    <Grid item lg={3} md={3} xs={12} className={`work-location ${(platform == "" || platform == "all") ? 'platform' : ""}`}>
                                        <Select
                                            id="workLocations"
                                            align="left"
                                            className="form-control input-group mb-0 campain"
                                            placeholder="Search by location"
                                            name="console-location"
                                            value={platform || "all"}
                                            autoHighlight
                                            onChange={(e) => {
                                                setPlatform(e.target.value);
                                                getCustomersOnBusinessType(e.target.value);
                                            }}
                                        >
                                            <MenuItem value="all" className="gray3">Search by platform</MenuItem>
                                            <MenuItem key="PSP" value="PSP">Post Office - SP</MenuItem>
                                            <MenuItem key="PBP" value="PBP">Post Office - BP</MenuItem>
                                            <MenuItem key="BH" value="BH">Bighat</MenuItem>
                                            <MenuItem key="EF" value="EF">Ease Farming</MenuItem>
                                            <MenuItem key="AM" value="AM">Amazon</MenuItem>
                                            <MenuItem key="FK" value="FK">Flipkart</MenuItem>
                                            <MenuItem key="JM" value="JM">Jio Mart</MenuItem>
                                            <MenuItem key="AB" value="AB">Agri Begri</MenuItem>
                                            <MenuItem key="TD" value="TD">Tru Deliver</MenuItem>
                                            <MenuItem key="BA" value="BA">Bharat Agri</MenuItem>
                                            <MenuItem key="KT" value="KT">Khethari</MenuItem>
                                            <MenuItem key="PF2" value="PF2">Platform 2</MenuItem>
                                            <MenuItem key="OF" value="OF">Offline</MenuItem>
                                        </Select>
                                    </Grid>
                                    <Grid item lg={4} md={4} xs={12}
                                        className="text-end customers-list-search-wrap"
                                    >
                                        <Box className="customers-list-search-row">
                                        <TextField
                                            inputRef={inputRef}
                                            name="searchKeyword"
                                            type="text"
                                            className="inputcontrasts position-issue postJob-search search-id w-100 new-search textEllipse-talent-search"
                                            variant="outlined"
                                            margin="normal"
                                            placeholder="Search for customer"
                                            onKeyPress={(e) => {
                                                handleSpaces(e);
                                                handleEnterKey(e);
                                            }}
                                            onInput={handleEnterKey}
                                            onKeyDown={handleEnterKey}
                                            value={searchKeyword}
                                            // {...register("searchKeyword")}
                                            InputProps={{
                                                endAdornment: (
                                                    <InputAdornment position="end">
                                                        {searchKeyword !== "" && (
                                                            <ClearIcon
                                                                onClick={() => {
                                                                    inputRef.current.value = "";
                                                                    clearSearch();
                                                                }}
                                                                style={{ marginRight: "5px" }}
                                                                aria-label="Clear icon"
                                                                className="cursor-hover"
                                                            />
                                                        )}
                                                        <Typography className="search-byId">
                                                            <Grid
                                                                className="border-radius-6 d-flex align-center cursor-hover"
                                                                style={{ padding: "12px 8px 12px 1px" }}
                                                                onClick={() => {
                                                                    if (
                                                                        searchKeyword !== "" &&
                                                                        searchKeyword !==
                                                                        previouslySearchedKeyword
                                                                    ) {
                                                                        search();
                                                                    }
                                                                }}
                                                                aria-label="Search icon"
                                                                disableRipple="true"
                                                            >
                                                                <SearchIcon
                                                                    width="18px"
                                                                    aria-label="search icon"
                                                                />
                                                            </Grid>
                                                        </Typography>
                                                    </InputAdornment>
                                                ),
                                            }}
                                        />
                                        {hasActiveFilters && (
                                            <BootstrapTooltip title="Clear calendar, platform and search filters">
                                                <IconButton
                                                    className="customers-clear-filters-btn"
                                                    onClick={clearAllFilters}
                                                    aria-label="Clear all filters"
                                                    size="small"
                                                >
                                                    <FilterListOffIcon fontSize="small" />
                                                </IconButton>
                                            </BootstrapTooltip>
                                        )}
                                        </Box>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Typography style={{ marginBottom: "-5px", alignItems: "baseline" }} className="d-flex justify-end">
                        {showDownload() && <Typography className="text-end">
                            {downloadLoader ? <span>Downloading...</span> : <Link
                                className="link-color f-16 font-weight-500 mr-10 download-hover"
                                style={{ textDecorationColor: getComputedStyle(document.documentElement).getPropertyValue('--primary-color') }}
                                tabIndex={0}
                                onClick={() => {
                                    if (previouslySearchedKeyword.toLowerCase() === "disputed") {
                                        downloadComplaintExcel("Disputed");
                                    } else if (previouslySearchedKeyword.toLowerCase() === "in-transit") {
                                        downloadComplaintExcel("In-transit");
                                    } else {
                                        downloadCustomerExcel(dateRange.start, dateRange.end);
                                    }
                                }}
                            >
                                {" "}
                                Download
                            </Link>}
                        </Typography>}
                        <Typography className="text-end f-14 pt-5">
                            Total quantity: {pairsCount},{" "} Prepaid Amount: ₹{prepaidAmount?.toLocaleString('en-IN')}
                        </Typography>
                    </Typography>
                    {/* <Grid>
                        <Grid className="d-flex justify-between job align-center joblist-header-section galaxy-block">
                            <Grid className="score-aged-align galaxy-fold-top jobs-ipad myjobs-ipad">
                                <Typography className="d-flex align-center">
                                    <Typography className="heading-text-color f-20 font-weight-600">
                                        {"Customers"}{" "}
                                    </Typography>
                                    <Box className="gray7 f-14 font-weight-400 ml-5">
                                        {"(" + totalCount + ")"}
                                    </Box>
                                </Typography>
                                <Box className="d-flex align-center justify-between">
                                    <Typography className="d-flex align-center mt-10 sPbalanceStatus">
                                        SP COD Received Amount : {spAmount?.received_amount || 0} <br />
                                        SP COD Balance Amount : {(spAmount?.balance_amount - spAmount?.received_amount) || 0}
                                    </Typography>
                                    <Typography className="d-flex align-center mt-10 bPbalanceStatus ml-10">
                                        BP COD Received Amount : {bpAmount?.received_amount || 0} <br />
                                        BP COD Balance Amount : {(bpAmount?.balance_amount - bpAmount?.received_amount) || 0}
                                    </Typography>
                                </Box>
                            </Grid>
                            <Grid
                                className="align-center d-flex search-job justify-end responsive-layout add-checklist-align jobs-ipad ml-10"
                            >
                                <Grid className={`work-location mr-10 ${(platform == "" || platform == "all") ? 'platform' : ""}`}>
                                                        <Select
                                                            id="workLocations"
                                                            align="left"
                                                            className="form-control input-group mb-0 campain"
                                                            placeholder="Search by location"
                                                            name="console-location"
                                                            value={platform || "all"}
                                                            autoHighlight
                                                            onChange={(e) => {
                                                                setPlatform(e.target.value);
                                                                getCustomersOnBusinessType(e.target.value);
                                                            }}
                                                        >
                                                            <MenuItem value="all" className="gray3">Search by platform</MenuItem>
                                                            <MenuItem key="PSP" value="PSP">Post Office - SP</MenuItem>
                                                            <MenuItem key="PBP" value="PBP">Post Office - BP</MenuItem>
                                                            <MenuItem key="BH" value="BH">Bighat</MenuItem>
                                                            <MenuItem key="AM" value="AM">Amazon</MenuItem>
                                                            <MenuItem key="FK" value="FK">Flipkart</MenuItem>
                                                            <MenuItem key="JM" value="JM">Jio Mart</MenuItem>
                                                            <MenuItem key="OF" value="OF">Offline</MenuItem>
                                                        </Select>
                                                    </Grid>
                                <Grid>
                                    {(dateFilter && totalCount > 0) && <Typography>
                                        <Link
                                            className="link-color f-16 font-weight-500 mr-10 download-hover"
                                            style={{ textDecoration: "none" }}
                                            tabIndex={0}
                                            onClick={() => {
                                                downloadCustomerExcel(dateRange.start, dateRange.end);
                                            }}
                                        >
                                            {" "}
                                            Download
                                        </Link>
                                    </Typography>}
                                </Grid>
                                <Grid item className="bluk-upload-daterangepicker mr-10">
                                    <DateRangePicker
                                        initialSettings={{
                                            startDate: start.toDate(),
                                            endDate: end.toDate(),
                                            ranges: {
                                                Today: [moment().toDate(), moment().toDate()],
                                                Yesterday: [
                                                    moment().subtract(1, 'days').toDate(),
                                                    moment().subtract(1, 'days').toDate(),
                                                ],
                                                'Last 7 Days': [
                                                    moment().subtract(6, 'days').toDate(),
                                                    moment().toDate(),
                                                ],
                                                'Last 30 Days': [
                                                    moment().subtract(29, 'days').toDate(),
                                                    moment().toDate(),
                                                ],
                                                'This Month': [
                                                    moment().startOf('month').toDate(),
                                                    moment().endOf('month').toDate(),
                                                ],
                                                'Last Month': [
                                                    moment().subtract(1, 'month').startOf('month').toDate(),
                                                    moment().subtract(1, 'month').endOf('month').toDate(),
                                                ],
                                            },
                                        }}
                                        onCallback={handleCallback}
                                        onCancel={handleClickOnCancel}
                                    >
                                        <div
                                            id="reportrange"
                                            className={dateFilter ? "col-4 chip-dropdown-active position-issue" : "col-4"}
                                            style={{
                                                background: '#fff',
                                                color: '#344054',
                                                cursor: 'pointer',
                                                borderRadius: '20px',
                                                padding: '5px 10px',
                                                border: '1px solid #667085',
                                                width: '100%',
                                            }}
                                        >
                                            <i className="fa fa-calendar"></i>&nbsp;
                                            <span style={{ color: dateFilter && "#fff" }}>{label}</span> <i className="fa fa-caret-down"></i>
                                        </div>
                                    </DateRangePicker>
                                </Grid>
                                <Box
                                    // ref={divRef}
                                    className="inputGroup responsive-view-align candidate-list-align galaxy-margin-right-0"
                                >
                                    <TextField
                                        inputRef={inputRef}
                                        name="searchKeyword"
                                        type="text"
                                        className="inputcontrasts position-issue postJob-search search-id new-search textEllipse-talent-search"
                                        variant="outlined"
                                        margin="normal"
                                        placeholder="Search for customer"
                                        onKeyPress={(e) => {
                                            handleSpaces(e);
                                            handleEnterKey(e);
                                        }}
                                        onInput={handleEnterKey}
                                        onKeyDown={handleEnterKey}
                                        value={searchKeyword}
                                        // {...register("searchKeyword")}
                                        InputProps={{
                                            endAdornment: (
                                                <InputAdornment position="end">
                                                    {searchKeyword !== "" && (
                                                        <ClearIcon
                                                            onClick={() => {
                                                                inputRef.current.value = "";
                                                                clearSearch();
                                                            }}
                                                            style={{ marginRight: "5px" }}
                                                            aria-label="Clear icon"
                                                            className="cursor-hover"
                                                        />
                                                    )}
                                                    <Typography className="search-byId">
                                                        <Grid
                                                            className="border-radius-6 d-flex align-center cursor-hover"
                                                            style={{ padding: "12px 8px 12px 1px" }}
                                                            onClick={() => {
                                                                if (
                                                                    searchKeyword !== "" &&
                                                                    searchKeyword !==
                                                                    previouslySearchedKeyword
                                                                ) {
                                                                    search();
                                                                }
                                                            }}
                                                            aria-label="Search icon"
                                                            disableRipple="true"
                                                        >
                                                            <SearchIcon
                                                                width="18px"
                                                                aria-label="search icon"
                                                            />
                                                        </Grid>
                                                    </Typography>
                                                </InputAdornment>
                                            ),
                                        }}
                                    />
                                </Box>
                            </Grid>
                        </Grid>
                    </Grid> */}
                    {firstTimeLoad ? (
                        <>
                            <div className="mt-24">
                                {[...Array(12)].map((e, i) => (
                                    <Typography className="display-flex align-center" key={i}>
                                        <div className="lazy-loader">
                                            <div className="">
                                                <Grid container spacing={1} className="">
                                                    <Grid className="shimmerBG img mx-8 px-8"></Grid>
                                                    <Grid
                                                        lg={2}
                                                        md={2}
                                                        xs={2}
                                                        className="shimmerBG title-line mx-8 px-8"
                                                    ></Grid>
                                                    <Grid
                                                        lg={1.5}
                                                        md={2}
                                                        xs={2}
                                                        className="shimmerBG title-line mx-8 px-8"
                                                    ></Grid>
                                                    <Grid
                                                        lg={1.5}
                                                        md={2}
                                                        xs={2}
                                                        className="shimmerBG title-line mx-8 px-8"
                                                    ></Grid>
                                                    <Grid
                                                        lg={1.5}
                                                        md={2}
                                                        xs={2}
                                                        className="shimmerBG title-line mx-8 px-8"
                                                    ></Grid>
                                                    <Grid
                                                        lg={1}
                                                        md={2}
                                                        xs={2}
                                                        className="shimmerBG title-line mx-8 px-8"
                                                    ></Grid>
                                                    <Grid
                                                        lg={1}
                                                        md={2}
                                                        xs={2}
                                                        className="shimmerBG title-line mx-8 px-8"
                                                    ></Grid>
                                                    <Grid
                                                        lg={1}
                                                        md={2}
                                                        xs={2}
                                                        className="shimmerBG title-line mx-8 px-8"
                                                    ></Grid>
                                                </Grid>
                                                <Grid container spacing={1}>
                                                    <Grid
                                                        lg={0.5}
                                                        md={2}
                                                        xs={2}
                                                        className="shimmerBG title-line mx-8 px-8"
                                                    ></Grid>
                                                    <Grid
                                                        lg={1.5}
                                                        md={2}
                                                        xs={2}
                                                        className="shimmerBG title-line mx-8 px-8"
                                                    ></Grid>
                                                    <Grid></Grid>
                                                    <Grid></Grid>
                                                    <Grid></Grid>
                                                    <Grid></Grid>
                                                </Grid>
                                            </div>
                                        </div>
                                    </Typography>
                                ))}
                            </div>
                        </>
                    ) : (
                        <Grid className="matching-view" id="talent-console-candidates">
                            {/* {isLoading && <Loader />} */}
                            <Typography>
                                <>
                                    {candidates?.length > 0 ? (
                                        <Grid
                                            container
                                            item
                                            className="mt-15 matching-list-view ipad-view-align"
                                        >
                                            <TableContainer
                                                component={Paper}
                                                className="no-table-border testing table-container table-list-align matching-list-align"
                                            >
                                                <Table
                                                    aria-label="simple table"
                                                    className="matching-table"
                                                >
                                                    <TableHead>
                                                        <TableRow>
                                                            <TableCell
                                                                key="Candidate Details"
                                                                align="left"
                                                                style={{ minWidth: "110px" }}
                                                                className="title-align align-center table-position"
                                                                sx={{ position: 'sticky', left: 0, backgroundColor: '#F2F4F7', zIndex: 1 }}
                                                            >Customer Name</TableCell>
                                                            {columns.map((C, index) => (
                                                                <TableCell
                                                                    align="left"
                                                                    className="vertical-align-top"
                                                                    style={{ minWidth: C.width }}
                                                                    key={index}
                                                                >
                                                                    {C.col}
                                                                </TableCell>
                                                            ))}
                                                            <TableCell
                                                                align="right"
                                                                className="w-13cent"
                                                                sx={{ position: 'sticky', right: 0, backgroundColor: '#F2F4F7', zIndex: 1 }}
                                                            >
                                                                Actions
                                                            </TableCell>
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody className="bg-white">
                                                        {candidates?.map((candidate, index) => (
                                                            <>
                                                                <TableRow
                                                                    key={index}
                                                                    className="cursor-hover"
                                                                    hover
                                                                >
                                                                    <TableCell
                                                                        align="left"
                                                                        sx={{ position: 'sticky', left: 0, zIndex: 1 }}
                                                                        className="list-matching table-position"
                                                                    >{candidate.name}</TableCell>
                                                                    {columns?.map((C, index) => (
                                                                        <TableCell
                                                                            key={index}
                                                                            align="left"
                                                                        >
                                                                            <Typography className="gray10 font-weight-400 f-14 mt-4">
                                                                                {C.key === 'is_printed' ? (candidate[C.key] ? 'Yes' : 'No' ) : C.key == 'address' ? <BootstrapTooltip title={candidate[C.key]} placement="top"><span className="textEllipse" style={{ width: C.width }}>{candidate[C.key]}</span></ BootstrapTooltip> : C.key == 'barcode' ? (candidate[C.key] ? <Box className="d-flex align-center" sx={{ gap: 0.5 }}>
                                                                                    <span>{candidate[C.key]}</span>
                                                                                    <BootstrapTooltip title="Copy tracking number" placement="top">
                                                                                        <IconButton
                                                                                            size="small"
                                                                                            className="p-0"
                                                                                            aria-label="Copy tracking number"
                                                                                            onClick={() => copyBarcodeTrackingNumber(candidate[C.key])}
                                                                                        >
                                                                                            <ContentCopyIcon sx={{ fontSize: '16px !important', color: '#667085' }} />
                                                                                        </IconButton>
                                                                                    </BootstrapTooltip>
                                                                                </Box> : '-') : C.key == 'payment_status' ? (candidate[C.key] ? <span className="availableStatus">{candidate[C.key]}</span> : "-") : C.key == 'order_status' ? <span className={`${candidate[C.key] == "Returned" ? 'expiryStatus' : candidate[C.key] == "Delivered" ? 'availableStatus' : candidate[C.key] == "In-transit" ? 'declineStatus' : candidate[C.key] == "Dispatched" ? 'dispatchStatus' : candidate[C.key] == "Pending" ? 'pendingStatus' : 'complaintStatus'}`}>
                                                                                    {candidate[C.key] ? candidate[C.key] : '-'}
                                                                                </span> : C.key == "size_details" ? <Box className="candidate-skills">
                                                                                    {candidate[C.key].map(
                                                                                        (skills, index) => {
                                                                                            return index < 1 ? (
                                                                                                <span
                                                                                                    key={index}
                                                                                                    className="skills text-initial"
                                                                                                >
                                                                                                    {skills.product_type}-{skills.size} ({skills.quantity})
                                                                                                </span>
                                                                                            ) : null;
                                                                                        }
                                                                                    )}
                                                                                    {candidate[C.key].length >
                                                                                        1 && (
                                                                                            <Box
                                                                                                style={{
                                                                                                    display: "inline-flex",
                                                                                                }}
                                                                                            >
                                                                                                <span
                                                                                                    className="cursor-hover link-color font-weight-600 f-12 pl-5"
                                                                                                    onClick={(e) =>
                                                                                                        handleClick(e, candidate[C.key])
                                                                                                    }
                                                                                                >{`+${candidate[C.key]
                                                                                                    .length - 1
                                                                                                    } more`}</span>
                                                                                            </Box>
                                                                                        )}
                                                                                </Box> : C.key == 'created_at' ? (candidate[C.key] ? moment(candidate[C.key]).format('YYYY-MM-DD') : '-') : C.key === 'is_printed' ? (candidate[C.key] === true ? 'Yes' : 'No' ) : ((C.key == 'cod' || C.key == 'received_cod_amount' || C.key == 'delivary_charges' || C.key == 'prepaid') && candidate[C.key] == 0) ? 0 : candidate[C.key] ? candidate[C.key] : '-'}
                                                                            </Typography>
                                                                        </TableCell>
                                                                    ))}
                                                                    <TableCell align="right" className="table-position" sx={{ position: 'sticky', right: 0, zIndex: 1 }}>
                                                                        <Box className="d-flex justify-end mt-4">
                                                                            <Typography className="matching-action-align d-flex align-center justify-end">
                                                                                <MeatballMenu
                                                                                    row={candidate}
                                                                                    updateCustomer={updateCustomer}
                                                                                    deleteCustomer={deleteCustomer}
                                                                                // openAddStage={openAddStage}
                                                                                />
                                                                            </Typography>
                                                                        </Box>
                                                                    </TableCell>
                                                                </TableRow>
                                                            </>
                                                        ))}
                                                    </TableBody>
                                                </Table>
                                            </TableContainer>
                                            {candidates?.length !== 0 && (
                                                <>
                                                    {" "}
                                                    <Grid
                                                        container
                                                        item
                                                        spacing={1}
                                                        className="align-between align-center pagenation-design mt-15 pb-20 galaxy-margin-0"
                                                    >
                                                        {totalCount > 10 && (
                                                            <>
                                                                <Grid
                                                                    item
                                                                    lg={6}
                                                                    md={6}
                                                                    xs={12}
                                                                    className="pagenation-table pt-5 galaxy-padding-left-0"
                                                                >
                                                                    <Typography className="d-flex f-14 align-center font-weight-500 galaxy-block  gal-slot-align">
                                                                        {/* <span className="d-flex align-center">
                                                                            <Box className="gray7">Showing</Box>
                                                                            <span className="count-jobs mx-6 p-5">
                                                                                10
                                                                            </span>
                                                                        </span>
                                                                        <Box className="gray7">
                                                                            customers per page
                                                                        </Box> */}
                                                                    </Typography>
                                                                </Grid>
                                                                <Grid
                                                                    item
                                                                    lg={6}
                                                                    md={6}
                                                                    xs={12}
                                                                    className="justify-end d-flex pagenation-table navbarUser pt-5 galaxy-padding-left-0"
                                                                >
                                                                    <Stack
                                                                        spacing={2}
                                                                        className="pagenation-joblist"
                                                                    >
                                                                        <Pagination
                                                                            shape="rounded"
                                                                            className="position-issue"
                                                                            // color="primary"
                                                                            rowsperpage={10}
                                                                            count={totalPages || Math.ceil(totalCount / 10) || 1}
                                                                            page={currentPage}
                                                                            onChange={handleChangePage}
                                                                            renderItem={(item) => (
                                                                                <PaginationItem
                                                                                    components={{
                                                                                        last: (props) => (
                                                                                            <button
                                                                                                className="btn primary-button profileButton"
                                                                                                aria-label="button"
                                                                                                {...props}
                                                                                            >
                                                                                                Last
                                                                                            </button>
                                                                                        ),

                                                                                        next: (props) => (
                                                                                            <Box
                                                                                                className="d-flex align-center cursor-hover"
                                                                                                {...props}
                                                                                            >
                                                                                                <Box className="gray7 f-14 align-center font-weight-500 ml-10 mr-20">
                                                                                                    Next
                                                                                                </Box>
                                                                                                <ArrowForwardIcon
                                                                                                    height="13px"
                                                                                                    width="13px"
                                                                                                />{" "}
                                                                                            </Box>
                                                                                        ),

                                                                                        first: (props) => (
                                                                                            <Box
                                                                                                className="d-flex align-center cursor-hover"
                                                                                                {...props}
                                                                                            >
                                                                                                <ArrowBackIcon
                                                                                                    height="13px"
                                                                                                    width="13px"
                                                                                                />{" "}
                                                                                                <Box className="gray7 f-14 align-center font-weight-500 ml-10 mr-15">
                                                                                                    Previous
                                                                                                </Box>
                                                                                            </Box>
                                                                                        ),

                                                                                        previous: (props) => (
                                                                                            <Box
                                                                                                className="d-flex align-center cursor-hover"
                                                                                                {...props}
                                                                                            >
                                                                                                <ArrowBackIcon
                                                                                                    height="13px"
                                                                                                    width="13px"
                                                                                                />{" "}
                                                                                                <Box className="gray7 f-14 font-weight-500 ml-10 mr-15">
                                                                                                    Previous
                                                                                                </Box>
                                                                                            </Box>
                                                                                        ),
                                                                                    }}
                                                                                    {...item}
                                                                                />
                                                                            )}
                                                                            showFirstButton={false}
                                                                            showLastButton={false}
                                                                        />
                                                                    </Stack>
                                                                </Grid>
                                                            </>
                                                        )}
                                                    </Grid>
                                                </>
                                            )}
                                        </Grid>
                                    ) : (
                                        <>
                                            <Grid
                                                item
                                                lg="12"
                                                className="align-item-center"
                                                sx={{ mt: 10 }}
                                            >
                                                <img
                                                    width="230px"
                                                    height="230px"
                                                    className="profile-video-thumbnail"
                                                    src={noCandidate}
                                                    alt="img"
                                                />
                                            </Grid>
                                            <Grid item lg="12" className="align-item-center">
                                                <Typography className="gray9 f-16 font-weight-700 mt-20">
                                                    No data found
                                                </Typography>
                                            </Grid>
                                        </>
                                    )}
                                </>
                            </Typography>
                        </Grid>
                    )}
                </Grid>
            </Grid>
            <Modal
                open={emailConfirmation}
                onClose={handleConfirmPopup}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box className="modal-content inputcontrasts">
                    <Typography className="align-left">
                        <Typography
                            id="modal-modal-title"
                            variant="h5"
                            className="font-weight-700"
                        >
                            Confirmation
                        </Typography>
                        <Typography sx={{ mt: 2 }} className="sub-text-font">
                            {/* {emailConfirmationContent} */}
                        </Typography>
                        <Typography className="text-end mt-20">
                            <Button
                                className="btn secondary-button m-r-10"
                                aria-label="button"
                            // onClick={handleConfirmPopup}
                            >
                                Cancel
                            </Button>
                            <Button
                                className="btn primary-button"
                                // onClick={() => proceedToCampaign()}
                                aria-label="verify"
                                disableRipple="true"
                            >
                                OK
                            </Button>
                        </Typography>
                    </Typography>
                </Box>
            </Modal>
            <Popover
                id={id}
                open={open}
                anchorEl={anchor}
                onClose={handleClosePopover}
                anchorOrigin={{
                    vertical: "-500",
                    horizontal: "200",
                }}
                anchorPosition={{
                    left: 500,
                }}
                transformOrigin={{
                    vertical: "300",
                    horizontal: "200",
                }}
            >
                <Grid item sx={{ p: 1 }}>
                    <Box className="align-between">
                        <Grid item xs={12} md={12}>
                            <Typography
                                id="modal-title"
                                className="d-flex align-between p-10"
                            >
                                <Typography variant="h5" className="f-16 font-weight-600 heading-text-color">
                                    Size Details
                                </Typography>
                                <Typography
                                    align="right"
                                    className="cursor-hover gray7 icon-button"
                                >
                                    <CloseIcon
                                        onClick={handleClosePopover}
                                        onKeyPress={handleClosePopover}
                                        aria-label="Close icon"
                                    />
                                </Typography>
                            </Typography>
                        </Grid>
                    </Box>
                    <Grid
                        item
                        className="p-10"
                        style={{ maxHeight: "250px", overflow: "auto", maxWidth: "300px" }}
                    >
                        <Box>
                            {skills.map((skill, index) => {
                                return (
                                    <span key={index} className="skills">
                                        {skill.product_type}-{skill.size} ({skill.quantity})
                                    </span>
                                );
                            })}
                        </Box>
                    </Grid>
                </Grid>
            </Popover>
            {/* ToastContainer is initialized in index.js */}
        </>
    );
}
